import styled from 'styled-components';

import { Format, StyleColor } from '../../utils/styles-constants';
import { hexToRgba, spin } from '../../utils/style';

const TableWrapper = styled('div')`
	flex: 1;
	margin: 30px -50px 0;
	padding: 0 50px;
	overflow-x: hidden;
	overflow-y: auto;

	@media ${Format.Smartphone} {
		margin: 30px -25px 0;
		padding: 0 25px;
	}
`;

const Loader = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	font-size: 21px;
	background-color: ${hexToRgba(StyleColor.White, 80)};

	svg {
		height: 35px;
		width: 35px;
		animation: ${spin};
		margin-right: 20px;
	}
`;

export {
	TableWrapper,
	Loader,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/styles.ts